import { FETCH_DEVICES } from './constants'
import { take, call, put, select } from 'redux-saga/effects'
import { apiFetchDevices } from './services'
import { fetchDevices } from './actions'
import languages from '../../constants/languages'
import { slugify } from '../../helpers/utils'

function* fetchDeviceWorker(currentCustomer) {
  const state = yield select()
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  const response = yield call(apiFetchDevices, preSaleFlag, language, customer)

  if (Array.isArray(response)) {
    const phones = response.map(phone => ({
      ...phone,
      slug: createSlug(phone)
    }))
    yield put(fetchDevices.success(phones, currentCustomer))
  }
}

export default function* watcher() {
  while (true) {
    let payload = yield take(FETCH_DEVICES.REQUEST)
    yield call(fetchDeviceWorker, payload.customer)
  }
}

const createSlug = (phone) => {
  if (phone.vanity_name) {
    return slugify(
      `${phone.manufacturer} ${phone.vanity_name} ${phone.name}`
    )
  }

  return slugify(`${phone.manufacturer} ${phone.name}`)
}



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/sagas.js